import { Box } from '@material-ui/core';
import { Currency, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { TimeIntervalSelector } from '@/components/modules/Metrics/MetricAggregateViews/components/TimeIntervalSelector';
import { MetricAggregateViews } from '@/components/modules/Metrics/MetricAggregateViews/MetricAggregateViews';
import { MetricAggregateViewsByProductExternal } from '@/components/modules/Metrics/MetricAggregateViews/MetricAggregateViewsByProductExternal';
import { TopMerchants } from '@/components/modules/Metrics/shared/components/TopMerchants/TopMerchants';
import { LOAN_STATUS_EXTERNAL_VALUES } from '@/components/modules/Metrics/shared/constants/LoanStatusExternalValues';
import { PRODUCT_EXTERNAL_VALUES } from '@/components/modules/Metrics/shared/constants/ProductExternalValues';
import { useLiveMetrics } from '@/components/modules/Metrics/shared/hooks/useLiveMetrics';
import { useMetricsScope } from '@/components/modules/Metrics/shared/hooks/useMetricsScope';
import { useTimeInterval } from '@/components/modules/Metrics/shared/hooks/useTimeInterval';
import { HomeHeader } from '@/components/shared/components/HomeHeader';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useScreen } from '@/hooks/useScreen';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MetricsHome = () => {
  const { userEntity } = useUserContext();

  const { sm } = useScreen(); //FIXME: provoking a re-render
  const { timeInterval, setTimeInterval } = useTimeInterval();
  useLiveMetrics(useMetricsScope());

  if (!userEntity) return null;

  return (
    <>
      <HomeHeader username={userEntity.name} />

      <Box display={'flex'} flexDirection={sm ? 'row' : 'column-reverse'} mt={sm ? 0 : 6}>
        <Box flexGrow={1}>
          <MetricAggregateViews
            currency={Currency.EUR}
            timeInterval={timeInterval}
            loanStatusExternal={LOAN_STATUS_EXTERNAL_VALUES}
          />
          <Box my={8} />
          <div
            style={{
              display: 'grid',
              gap: 48,
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              marginBottom: 300,
            }}
          >
            <MetricAggregateViewsByProductExternal
              currency={Currency.EUR}
              timeInterval={timeInterval}
              loanStatusExternal={[LoanStatusExternal.CONFIRMED]}
              productExternal={PRODUCT_EXTERNAL_VALUES}
            />
            <TopMerchants timeInterval={timeInterval} />
          </div>
        </Box>
        <Box margin={sm ? '0 0 0 24px' : '0 auto 24px'} position={sm ? 'block' : 'relative'}>
          <TimeIntervalSelector
            type={sm ? 'button' : 'select'}
            timeInterval={timeInterval}
            setTimeInterval={setTimeInterval}
            style={{
              position: 'sticky',
              top: 160,
            }}
          />
        </Box>
      </Box>
      {/* <HomeShortcuts /> */}
    </>
  );
};

export const MetricsHomeModule = withPermissionsModule(MetricsHome);
